import { TIME } from '../constants/time.constants';

export const getMinutesDuration = (days: number, hours: number, minutes: number) => {
  const daysToMinutes = (days * TIME.DAY) / TIME.MINUTE;
  const hoursToMinutes = (hours * TIME.HOUR) / TIME.MINUTE;
  const minutesDuration = daysToMinutes + hoursToMinutes + minutes;

  return minutesDuration;
};

export const parseMinutes = (minutes: number): { days: number; hours: number; minutes: number } => {
  const days = Math.floor(minutes / (24 * 60));
  const hours = Math.floor((minutes % (24 * 60)) / 60);
  const remainingMinutes = minutes % 60;

  return { days, hours, minutes: remainingMinutes };
};
